import { mapGetters } from "vuex";
import store from "@/store";
import MainLayout from "@/components/layout/MainLayout.vue";
import axios from "axios";

export default {
    name: "delete",

    components: {
        MainLayout
    },

    data() {
        return {
            showNav: false,
            show: false,
            userInfo: store.state.user.accountuser,
            userData: store.state.user,
            isuser: this.$store.state.user.length == 0 ? false : true
        };
    },

    computed: {
        ...mapGetters({
            teacherId: "teacherId", studentId: "studentId", schoolId: "schoolId"
        }),
    },

    methods: {
        async deleteTeacherAccount(teacherId) {
            return axios.post("deleteTeacher", {teacher_id: teacherId})
                .then(() => {
                    this.$store.commit('deleteTeacher');
                    window.location.replace('/');
                    this.$modal.hide("dialog");
                })
                .catch((error) => {
                    console.log("Delete Teacher API Error", error.response);
                    this.$modal.hide("dialog");
                });
        },

        async deleteStudentAccount(studentId) {
            return axios.post("deleteStudent", {student_id: studentId})
                .then(() => {
                    this.$store.commit('deleteStudent');
                    window.location.replace('/');
                    this.$modal.hide("dialog");
                })
                .catch((error) => {
                    console.log("Delete Student API Error", error.response);
                    this.$modal.hide("dialog");
                });
        },
        
        async deleteSchoolAccount(schoolId) {
            return axios.post("deleteSchool", { school_id: schoolId })
                .then(() => {
                    this.$store.commit('deleteSchool');
                    window.location.replace('/');
                    this.$modal.hide("dialog");
                })
                .catch((error) => {
                    console.log("Delete School API Error", error.response);
                    this.$modal.hide("dialog");
                });
        },
        
        confirmDelete() {
            this.$modal.show("dialog", {
                title: "အကောင့်ဖျက်မှာ သေချာပါသလား?",
                buttons: [{
                        title: "ဖျက်မည်",
                        handler: () => {
                            switch (this.userData.usertype) {
                                case 'teacher':
                                    this.deleteTeacherAccount(this.userInfo.teacher_id)
                                break
                                case 'student':
                                    this.deleteStudentAccount(this.userInfo.student_id)
                                break
                                case 'school':
                                    this.deleteSchoolAccount(this.userInfo.school_id)
                                break
                            }
                        }
                    },
                    {
                        title: "ပယ်ဖျက်ရန်",
                        handler: () => {
                            this.$modal.hide('dialog');
                        },
                    }
                ]
            });
        },
        
        getDetailTeacher() {
            axios.get("/profile")
                .then((response) => {
                    this.userInfo = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Teacher Detail API Error", error);
                });
        },
    },
    
    created() {
        this.getDetailTeacher();
    }
};
